/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_linesearch.js                                                                      */
/**********************************************************************************************************************/
/* Subscriptions Linesearch */
HafasWebapp.prototype.subscriptions.LineSearch = function (_me) {

  if (Hafas.Config.Switches.useLineSearch) {

    Hafas.ps.sub('/linesearch/setProductFormFilter', Hafas.bind(_me.Controller.LineSearch.setProductFormFilter, _me.Controller.LineSearch));

    Hafas.ps.sub('/app/events/closeResults', Hafas.bind(_me.Controller.LineSearch.hideLineDetails, _me.Controller.LineSearch));

    Hafas.ps.sub('/linesearch/selectLineFromFav', Hafas.bind(_me.Controller.LineSearch.selectLineFromFav, _me));
    Hafas.ps.sub('/linesearch/selectLineFromHist', Hafas.bind(_me.Controller.LineSearch.selectLineFromHist, _me));
    Hafas.ps.sub('/linesearch/selectLineFromNearList', Hafas.bind(_me.Controller.LineSearch.selectLineFromNearList, _me.Controller.LineSearch));

    Hafas.ps.sub('/linesearch/result/selectJourney', Hafas.bind(_me.Controller.LineSearch.selectJourney, _me.Controller.LineSearch));
    Hafas.ps.sub('/linesearch/result/setActiveStation', Hafas.bind(_me.Controller.LineSearch.setActiveStation, _me.Controller.LineSearch));
    Hafas.ps.sub('/linesearch/addLineToFav', Hafas.bind(_me.Controller.LineSearch.saveLineAsFavorite, _me.Controller.LineSearch));
    Hafas.ps.sub('/linesearch/removeLineFromFav', Hafas.bind(_me.Controller.LineSearch.deleteLineFromFavorite, _me.Controller.LineSearch));
    Hafas.ps.sub('/linesearch/showMap', Hafas.bind(_me.Controller.LineSearch.showMap, _me.Controller.LineSearch));
    Hafas.ps.sub('/linesearch/hideMap', Hafas.bind(_me.Controller.LineSearch.hideMap, _me.Controller.LineSearch));
    Hafas.ps.sub('/linesearch/redrawLine', Hafas.bind(_me.Controller.LineSearch.redrawLine, _me.Controller.LineSearch));

    Hafas.ps.sub('/suggest/setLocation', Hafas.bind(function (id, line) {
      if (id === 'HFS_searchLineInput' && typeof id === 'string' && line !== null && typeof line === 'object') {
        this.Controller.LineSearch.setSelectedLine(line);
      }
    }, _me));

    Hafas.ps.sub("/linesearch/clearInput", Hafas.bind(_me.Controller.LineSearch.clearInput, _me));

    // Favorites
    Hafas.ps.sub('/favorites/update', Hafas.bind(_me.Controller.LineSearch.favoritesUpdated, _me.Controller.LineSearch));

    // Linesearch
    Hafas.ps.sub('/linesearch/search', Hafas.bind(_me.Controller.LineSearch.searchLine, _me.Controller.LineSearch));

    Hafas.ps.sub('/GUI/leaveContext/LineSearch', Hafas.bind(_me.Controller.LineSearch.cleanup, _me));

    // History Back
    Hafas.ps.sub('/GUI/closeView/LineSearch', Hafas.bind(_me.Controller.LineSearch.closeView, _me));
    Hafas.ps.sub('/GUI/restoreView/LineSearch', Hafas.bind(_me.Controller.LineSearch.restoreView, _me));

    //popupover
    Hafas.ps.sub('/linesearch/showPopover', Hafas.bind(_me.Controller.LineSearch.showListsPopover, _me));
    Hafas.ps.sub('/linesearch/closePopover', Hafas.bind(_me.Controller.LineSearch.hideListsPopover, _me));
  }

};
